import Layout from "@/app/common-modules/layout/Layout";
const commonRouter = [
  // {
  //   path: "",
  //   component: Layout,
  //   redirect: "index",
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("@/app/dashboard/dashboard.vue"),
  //       name: "Dashboard",
  //       meta: {
  //         title: "index",
  //         icon: "dashboard",
  //         noCache: true,
  //         affix: true
  //       }
  //     }
  //   ]
  // },
  // {
  //   component: Layout,
  //   path: "",
  //   redirect: "waitToDo",
  //   name: "WaitToDo",
  //   children: [
  //     {
  //       path: "waitToDo",
  //       component: () => import("@/app/common-modules/waitToDo/index"),
  //       name: "waitToDo",
  //       meta: {
  //         title: "index",
  //         icon: "dashboard",
  //         noCache: true,
  //         affix: true
  //       }
  //     }
  //   ]
  // },
  {
    component: Layout,
    path: "/singleSignOn",
    redirect: "/singleSignOn",
    name: "singleSignOns",
    children: [
      {
        path: "/singleSignOn",
        component: () => import("@/app/singleSignon/views/index"),
        name: "singleSignOn"
      }
    ]
  },
  {
    path: "/to-be-built",
    component: Layout,
    redirect: "/to-be-built",
    name: "to-be-built",
    meta: {
      title: "待建",
      icon: "nested"
    },
    children: [
      {
        path: "index",
        component: () => import("@/app/common-modules/under-contribute/index"),
        name: "to-be-built-index",
        meta: {
          title: "建设中..."
        }
      }
    ]
  },
  {
    path: "/404",
    component: () => import("@/app/common-modules/error-page/views/404-new"),
    hidden: true
  },
  {
    path: "/305",
    component: () => import("@/app/common-modules/error-page/views/305"),
    hidden: true
  },
  {
    path: "/405",
    component: Layout,
    redirect: "/405-page",
    name: "405",
    meta: {
      title: "405",
      icon: ""
    },
    children: [
      {
        path: "/405-page",
        component: () => import("@/app/common-modules/error-page/views/405"),
        name: "405-page",
        meta: {
          title: "405"
        }
      }
    ]
  }
];

export default commonRouter;
